{
    "PartitionModal_AddTitle": "Adicionar Partição",
    "PartitionModal_ChangeTitle": "Alterar partição",
    "PartitionModal_ViewTitle": "Visualizar Partição",
    "PartitionModal_PromptMessage": "Você tem alterações de partição não salvas. Deseja sair sem salvar?",
    "PartitionModal_PromptConfirm": "Saída",
    "PartitionModal_PromptCancel": "Cancelar",
    "PartitionModal_Tab_Details": "Detalhes",
    "PartitionModal_Tab_SiteSettings": "Configurações do site",
    "PartitionModal_Tab_Synchronisation": "Sincronização",
    "PartitionModal_Tab_Advanced": "Avançado",
    "PartitionModal_Tab_CommunicationStatus": "Status de sincronização",
    "PartitionModal_Loading": "Carregando...",
    "PartitionModal_Button_Close": "Fechar",
    "PartitionModal_Button_Cancel": "Cancelar",
    "PartitionModal_Button_Save": "Salvar",
    "PartitionModal_RequestFailed": "A solicitação falhou",
    "PartitionModal_General_Description": "Descrição",
    "PartitionModal_General_DescriptionRequired": "É necessário descrever o processo.",
    "PartitionModal_General_IDInTelSys": "Não no servidor de telefonia (automático)",
    "PartitionModal_General_IDInTelSysRequired": "Não é necessário ter um servidor de telefonia.",
    "PartitionModal_General_Tags": "Marcação",
    "PartitionModal_Details_Identifier": "Identificador",
    "PartitionModal_Details_IdentifierPlaceholder": "[Atribuído automaticamente]",
    "PartitionModal_Details_BillingIdOrTag": "ID de faturamento \/ Etiqueta",
    "PartitionModal_Details_BilledMonthly": "Cobrado mensalmente",
    "PartitionModal_Details_LicensedFor": "Licenciado para",
    "PartitionModal_Details_DeleteAcdAgentsOnDowngrade": "Excluir automaticamente as entradas do agente ACD",
    "PartitionModal_LicensedFor_None": "Nenhum",
    "PartitionModal_LicensedFor_AkixiLite": "Akixi Lite",
    "PartitionModal_LicensedFor_AkixiBLF": "Akixi BLF",
    "PartitionModal_LicensedFor_AkixiONE": "Akixi UM",
    "PartitionModal_LicensedFor_Akixi1000": "Akixi 1000",
    "PartitionModal_LicensedFor_Enterprise": "Empresa",
    "PartitionModal_LicensedFor_Akixi2000": "Akixi 2000",
    "PartitionModal_LicensedFor_Essentials": "Essenciais",
    "PartitionModal_LicensedFor_Professional": "Profissional",
    "PartitionModal_LicensedFor_CallCentreAgent": "Agente de Call Center",
    "PartitionModal_LicensedFor_CallCentreSupervisor": "Supervisor de Call Center",
    "PartitionModal_Details_CommonDevices": "Contém dispositivos comuns",
    "PartitionModal_Details_CommonDevicesPanasonic": "Contém dispositivos comuns (somente DP comum)",
    "PartitionModal_Details_CommunicationEnabled": "Comunicação habilitada",
    "PartitionModal_Site_Timezone": "Fuso horário",
    "PartitionModal_Site_StartOfDay": "Início do dia (hora local)",
    "PartitionModal_Site_RecordingPlayback": "Gravação Reprodução",
    "PartitionModal_Site_RecordingPlayback_None": "Nenhum",
    "PartitionModal_Site_E164Enabled": "E.164 ativado",
    "PartitionModal_Site_InternalDigitLength": "Comprimento do dígito interno",
    "PartitionModal_Site_CountryCodeLocation": "Localização do código do país",
    "PartitionModal_Sync_NoSettings": "Nenhuma configuração de sincronização se aplica a este tipo de servidor de telefonia.",
    "PartitionModal_Sync_CommonDevicesNoSettings": "Nenhuma configuração de sincronização se aplica a uma partição de dispositivos comuns.",
    "PartitionModal_Sync_NameOnTelephonyServer": "Nome no servidor de telefonia",
    "PartitionModal_Sync_IDOnTelephonyServerOid": "ID no servidor de telefonia (OID)",
    "PartitionModal_Sync_SynchronisationTypeSoftOnly": "Tipo de sincronização (somente software)",
    "PartitionModal_Sync_EnterpriseOrProviderID": "ID da empresa ou do provedor",
    "PartitionModal_Sync_SynchronisationType": "Tipo de sincronização",
    "PartitionModal_Sync_WebexEnvironmentType": "Tipo de ambiente Webex",
    "PartitionModal_Sync_TeamsEnvironmentType": "Tipo de ambiente de equipes",
    "PartitionModal_Sync_EnterpriseID": "ID da empresa",
    "PartitionModal_Sync_GroupID": "ID do grupo",
    "PartitionModal_Sync_UserInLocation": "Usuário em Localização",
    "PartitionModal_Sync_IDOnTelephonyServer": "ID no servidor de telefonia",
    "PartitionModal_Sync_TypeOnTelSys": "Digite no Telsys",
    "PartitionModal_Sync_WebexTypeEnvironment": "Ambiente do tipo Webex",
    "PartitionModal_Sync_ComponentType_Unknown": "[Tipo desconhecido ou não especificado]",
    "PartitionModal_Sync_ComponentType_BroadWorks_Enterprise": "Empresa",
    "PartitionModal_Sync_ComponentType_BroadWorks_EnterpriseGroup": "Grupo Empresarial",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProvider": "Prestador de Serviços",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProviderGroup": "Grupo de Prestadores de Serviços",
    "PartitionModal_Sync_ComponentType_Webex_Organisation": "Organização",
    "PartitionModal_Sync_ComponentType_Webex_Location": "Localização",
    "PartitionModal_Sync_Environment_None": "Nenhum",
    "PartitionModal_Sync_Environment_Tenant": "Inquilino",
    "PartitionModal_Sync_Environment_AuthoriserSelect": "Selecionar autorizador",
    "PartitionModal_Sync_Environment_SecurityGroups": "Grupos de segurança",
    "PartitionModal_Sync_SynchronisationType_Soft": "Macio",
    "PartitionModal_Sync_SynchronisationType_OneTimeFull": "Pagamento único completo",
    "PartitionModal_Sync_SynchronisationType_Full": "Completo",
    "PartitionModal_Sync_SynchronisationType_ServicePack": "Pacote de serviços",
    "PartitionModal_Sync_SecurityGroups": "Grupos de segurança",
    "PartitionModal_Sync_SyncOptions": "Opções de sincronização",
    "PartitionModal_Sync_SyncOptions_None": "Nenhum",
    "PartitionModal_Sync_SyncOptions_Endpoints": "Pontos finais",
    "PartitionModal_Sync_SyncOptions_Trunking": "Troncos",
    "PartitionModal_Sync_SyncOptions_Agents": "Agentes + Extensões Associadas",
    "PartitionModal_Sync_SyncOptions_Supervisors": "Supervisores",
    "PartitionModal_Sync_MaintainParity": "Manter a paridade",
    "PartitionModal_Sync_ForceMonitored": "monitoramento forçado",
    "PartitionModal_Sync_SupervisorPermissions": "Habilitar permissões de supervisor do servidor de telefonia por padrão",
    "PartitionModal_Sync_SyncNow": "Sincronizar agora",
    "PartitionModal_Sync_PhotoSyncNow": "Sincronize suas fotos agora",
    "PartitionModal_Advanced_CtiLoggingEnabled": "Registro CTI",
    "PartitionModal_Advanced_Trunking": "Troncos",
    "PartitionModal_Advanced_TrunkingBurst": "Tronco (estouro)",
    "PartitionModal_Advanced_TrunkingCapacity": "Capacidade de troncos",
    "PartitionModal_Advanced_TrunkingCapacityBurst": "Capacidade de Tronco (Burst)",
    "PartitionModal_Advanced_TrunkCapacity": "Capacidade do porta-malas",
    "PartitionModal_Advanced_TrunkCapacityBurst": "Capacidade do porta-malas (rompimento)",
    "PartitionModal_CommStatus_SyncStatusTitle": "Status de sincronização",
    "PartitionModal_CommStatus_SyncLastStarted": "Última vez iniciado em:",
    "PartitionModal_CommStatus_SyncLastStarted_Placeholder": "—",
    "PartitionModal_CommStatus_SyncLastError": "Estado de sincronização \/ erro",
    "PartitionModal_CommStatus_SyncLastError_Placeholder": "Ainda não há informações disponíveis sobre o status da sincronização.",
    "NAME": "PartitionModal"
}